import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import TopNavigation from '../components/TopNavigation';
import JobRequestModal from 'parent-portal/forms/JobRequestModal';
import BusinessJobRequestModal from 'parent-portal/forms/BusinessJobRequestModal';

export const Private = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            if (localStorage.getItem('token') !== null) {
                return (
                    <>
                        <TopNavigation />
                        <BusinessJobRequestModal />
                        <JobRequestModal />
                        <Component {...props} />
                    </>
                );
            }

            const pathname = props.location?.pathname?.indexOf('sitter/') > -1 ? '/sitter' : '/';

            return <Redirect to={{ pathname, search: props.location.search, state: { from: props.location } }} />;
        }}
    />
);
